import Description from '../components/FormItems/Description'
import Notice from '../components/FormItems/Notice'
import SingleCheckbox from '../components/FormItems/SingleCheckbox'
import TextField from '../components/FormItems/TextField'
import PlanSelector from '../components/FormItems/PlanSelector'
import SubscribingStatus from '../components/FormItems/SubscribingStatus'
import SubmitButton from '../components/FormItems/SubmitButton'

import { formState, formGetters, formMutations, formActions } from '../store_mixins/form'

export default {
  components: {
    Description,
    Notice,
    SingleCheckbox,
    TextField,
    PlanSelector,
    SubscribingStatus,
    SubmitButton,
  },
  props: {
    namespace: {
      type: String,
      required: false,
      default: 'common',
    },
    fieldGroup: {
      type: String,
      required: true,
    },
    formAction: {
      type: String,
      required: true,
    },
    formMethod: {
      type: String,
      required: false,
      default: undefined,
    },
    isVisibleRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  computed: {
    values() {
      return this.$store.state[this.namespace].values
    },
    isSubmitting() {
      return this.$store.state[this.namespace].isSubmitting
    },
    isFailedSubmitting() {
      return this.$store.state[this.namespace].isFailedSubmitting
    },
    fields() {
      return this.$store.getters[`${this.namespace}/fields`]
    },
    fieldNames() {
      return this.$store.getters[`${this.namespace}/fieldNames`]
    },
    conditions() {
      return this.$store.getters[`${this.namespace}/conditions`]
    },
  },
  created() {
    this.registerModule()
    this.setNameSpace(this.namespace)
    this.setFieldGroup(this.fieldGroup)
    this.initValues()
  },
  methods: {
    setNameSpace(value) {
      this.$store.commit(`${this.namespace}/setNameSpace`, value)
    },
    setFieldGroup(value) {
      this.$store.commit(`${this.namespace}/setFieldGroup`, value)
    },
    initValues() {
      this.$store.dispatch(`${this.namespace}/initValues`)
    },
    onSubmit() {
      this.$store.dispatch(`${this.namespace}/onSubmit`)
    },
    getComponentNameByField(field) {
      switch (field.type) {
        case 'component':
          return field.componentName
        case 'checkbox':
          return 'SingleCheckbox'
        default:
          return 'TextField'
      }
    },
    registerModule() {
      this.$store.registerModule(this.namespace, {
        namespaced: true,
        state: {
          ...formState,
        },
        getters: {
          ...formGetters,
          conditions(state, getters) {
            return {
              planConfirmation:
                state.values.plan_selector !== 'free' &&
                state.values.plan_selector !== getters.currentUser.plan_key,
            }
          },
        },
        mutations: {
          ...formMutations,
        },
        actions: {
          ...formActions,
        },
      })
    },
  },
}
